import React from 'react';

function Contact() {
  return (
    <div className="feedback-content">
      <h1>We would love to hear back from you..</h1>
    
      <div className="feedback-section">  
      <h2>Here are some point of contact:</h2>
      <p></p>
      <ul>
        <li>
          <div className="feedback-item">
          <h3>If you like to subscribe and you stll have some questions</h3>
          <div>
            <img src="../img/email.png" alt="email" />
            <a href="mailto:info@cuetraders.com?body= Love your app, and  would like to start trial for a monthly digital subscription">
              Click here to start: Love your app, and  would like to start trial for a monthly digital subscription" ...
            </a>
          </div>
        </div>
        </li>
        <li>
          <div className="feedback-item">
          <h3>If you already a customer and need help in any aspect of your trading process</h3>
          <div>  
            <img src="../img/email.png" alt="email" />
            <a href="mailto:info@cuetraders.com?body= I'm and existing customenr, I need the following:  ">
             click to conatct email support: I'm and existing customenr, I need the following: 
            </a>
          </div>
        </div>
        </li>
        <li>
          <div className="feedback-item">
          <h3>Prefer to talk in person</h3>
          <div>
            <img src="../img/email.png" alt="email" />
            <a href="mailto:info@cuetraders.com?body=Prefer it to talk in person, please reach out to me on the following number: ">
             Click here to email phone/Whatsapp support: Prefer it to talk in person, please reach out to me on the following number ...
            </a>
          </div>
        </div>
        </li>
        <li>
        <div className="feedback-item">
          <h3>Cancel my serive</h3>
          <div>
            <img src="../img/email.png" alt="email:" />
            <a href="mailto:info@cuetraders.com?body=I would like to cancel my membership, please cancel before the next billing cycle. ">
            Click here to emai customer happiness: I would like to cancel my membership, please cancel before the next billing cycle....
            </a>
          </div>
          </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
/*
const Contact = () => {
  return (
    <div className="content">
        <h1>Email us your feedbak:</h1>
    <div>
        <h3> love it! </h3> 
            <span>  
                <img src="./img/email.png" alt="email"/>
                <a href="mailto:info@cuetraders.com?body=Love your site..">Love your app... </a>
             </span>
        <h3> needs improvement </h3>
            <span>  
                <img src="./img/email.png"  alt="email"/>
                <a href="mailto:info@cuetraders.com?body=Sugggest the following.. ">Sugggest the following... </a>
            </span>
        <h3> prefer the mobile app </h3>
            <span>  
            <img src="./img/email.png"  alt="email"/>
            <a href="mailto:info@cuetraders.com?body=Prefer the app because.. ">Prefer your mobile app because...</a>
            </span>
        <h3> don't like it </h3>
        <span>
            <img src="./img/email.png"  alt="email:"/> 
            <a href="mailto:info@cuetraders.com?body=Start over because.. ">Start over because... </a>
        </span> 
     </div>
    </div>
  );
};
*/
export default Contact;

